import { QUESTION_TYPES } from '../constants';

export const moveQuestionAfterFollowUpGroup = (
  questionsToRemove, // To remove from follow-up group and move after
  surveyToModify,
  followUpGroup,
  dontAutomaticallyRemoveFollowUpGroup
) => {
  const surveyToModifyData = surveyToModify;

  if (questionsToRemove && questionsToRemove.length > 0) {
    // Remove questions from follow-up group
    const groupIndex = surveyToModifyData.content.groups.findIndex(
      g => g.id === followUpGroup.id
    );
    surveyToModifyData.content.groups[
      groupIndex
    ].flows = surveyToModifyData.content.groups[groupIndex].flows.filter(
      f => questionsToRemove.indexOf(f) === -1
    );

    // Position them after follow-up group
    const existingFollowGroupFlowIdIndex = surveyToModifyData.content.flows.indexOf(
      followUpGroup.id
    );

    questionsToRemove.forEach(questionId => {
      surveyToModifyData.content.flows.splice(
        existingFollowGroupFlowIdIndex + 1,
        0,
        questionId
      );
    });

    // Check if group is empty now and remove it
    if (
      surveyToModifyData.content.groups[groupIndex].flows &&
      !surveyToModifyData.content.groups[groupIndex].flows.length &&
      !dontAutomaticallyRemoveFollowUpGroup
    ) {
      // Remove group
      surveyToModifyData.content.groups = surveyToModifyData.content.groups.filter(
        g => g.id !== followUpGroup.id
      );

      // Remove group id from content
      surveyToModifyData.content.flows = surveyToModifyData.content.flows.filter(
        f => f !== followUpGroup.id
      );
    }
  }

  return surveyToModifyData;
};

const removedNotJumpQuestionFromFollowUpGroup = (
  multipleAnswerMCQuestion,
  followUpGroup,
  surveyToModify,
  existingFollowGroupFlowIdIndex
) => {
  const surveyToModifyData = surveyToModify;

  const followUpGroupQuestions = followUpGroup.flows;
  const questionsToJumpFromMultipleAnswerMCQuestion =
    multipleAnswerMCQuestion &&
    multipleAnswerMCQuestion.choices &&
    multipleAnswerMCQuestion.choices.length &&
    multipleAnswerMCQuestion.choices.reduce((acc, choice) => {
      if (choice && choice.nextFlow) {
        return [...acc, choice.nextFlow];
      }
      return acc;
    }, []);

  const questionsToRemove = followUpGroupQuestions.reduce((acc, questionId) => {
    if (
      questionsToJumpFromMultipleAnswerMCQuestion &&
      questionsToJumpFromMultipleAnswerMCQuestion.length &&
      questionsToJumpFromMultipleAnswerMCQuestion.indexOf(questionId) === -1
    ) {
      return [...acc, questionId];
    }
    return acc;
  }, []);

  moveQuestionAfterFollowUpGroup(
    questionsToRemove, // To remove from follow-up group and move after
    surveyToModifyData,
    followUpGroup,
    existingFollowGroupFlowIdIndex
  );
};

const processSingleMultipleAnswerMC = (
  surveyToModify,
  multipleAnswerMCQuestion
) => {
  const followUpGroup =
    surveyToModify.content &&
    surveyToModify.content.groups.find(
      g => g.followUp && g.followUp.toString() === multipleAnswerMCQuestion.id
    );

  if (followUpGroup) {
    const existingFollowGroupFlowIdIndex = surveyToModify.content.flows.indexOf(
      followUpGroup.id
    );
    if (existingFollowGroupFlowIdIndex > -1) {
      // eslint-disable-next-line
      surveyToModify.content.flows = surveyToModify.content.flows.filter(
        f => f !== followUpGroup.id
      );
    }

    const flowIdIndex = surveyToModify.content.flows.findIndex(
      f => f.toString() === multipleAnswerMCQuestion.id.toString()
    );
    surveyToModify.content.flows.splice(flowIdIndex + 1, 0, followUpGroup.id);

    // Questions that are added, or by other issue positioned in the follow up group and that should be not part of put after the follow up group
    if (followUpGroup) {
      removedNotJumpQuestionFromFollowUpGroup(
        multipleAnswerMCQuestion,
        followUpGroup,
        surveyToModify,
        existingFollowGroupFlowIdIndex
      );
    }
  }
};

export default surveyToModify => {
  const multupleAnswerMCQuestions = Object.values(
    surveyToModify.survey.questions
  ).filter(
    q =>
      q.type === QUESTION_TYPES.MULTIPLE_CHOICE &&
      q.selectAtMost > 1 &&
      !q.followUpDisabled
  );

  multupleAnswerMCQuestions.map(q =>
    processSingleMultipleAnswerMC(surveyToModify.survey, q)
  );
};
